<template>
  <div>
    <Form @submit="submit">
      <Field
        :class="disabledUnit ? 'disabled' : ''"
        :disabled="disabledUnit"
        clearable
        v-model="device.unitName"
        label="所属单位"
        placeholder="请选择所属单位"
        readonly
        right-icon="arrow-down"
        @click="unitPanel = true"
        :rules="[{ required: true, message: '所属单位必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/unit.png" />
      </Field>
      <Field
        :class="disabledUnitGroup ? 'disabled' : ''"
        :disabled="disabledUnitGroup"
        clearable
        v-model="device.unitGroupName"
        label="归属分组"
        placeholder="请选择归属分组"
        readonly
        :right-icon="
          device.unitGroupName == '' || device.unitGroupName == null
            ? 'arrow-down'
            : 'close'
        "
        @click-right-icon="
          device.unitGroupName == '' || device.unitGroupName == null
            ? (unitGroupPanel = true)
            : empty()
        "
        @click-input="unitGroupPanel = true"
      >
        <img slot="left-icon" src="../../assets/img/unit.png" />
      </Field>
      <Field
        :class="disabledProduct ? 'disabled' : ''"
        clearable
        v-model="device.productName"
        label="产品类型"
        placeholder="请选择产品类型"
        readonly
        right-icon="arrow-down"
        @click="selectProduct()"
        :disabled="disabledProduct"
        :rules="[{ required: true, message: '产品类型必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/product.png" />
      </Field>
      <Field
        clearable
        v-model="device.name"
        label="设备名称"
        placeholder="请输入设备名称"
        :rules="[{ required: true, message: '设备名称必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/edit.png" />
      </Field>
      <Field
        :class="disabledUnit ? 'disabled' : ''"
        clearable
        v-model="device.sn"
        label="设备编号"
        placeholder="输入设备编号或扫一扫"
        :rules="[{ required: true, message: '设备编号必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/qrCode.png" />
        <WeChatIcon slot="right-icon" name="scan" @click="qrScan" />
      </Field>
      <!-- 验证码 -->
      <Field
        clearable
        v-model="device.ioTHubRemark"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '验证码必填' }]"
        v-if="code"
      >
        <img slot="left-icon" src="../../assets/img/edit.png" />
      </Field>
      <Field
        :class="disabledProduct ? 'disabled' : ''"
        :disabled="disabledProduct"
        clearable
        v-model="device.areaName"
        label="所属区域"
        placeholder="请选择所属区域"
        readonly
        right-icon="arrow-down"
        @click="areaPanel = true"
        :rules="[{ required: true, message: '所属区域必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/area.png" />
      </Field>
      <Field
        :class="disabledMap ? 'disabled' : ''"
        clearable
        v-model="device.location"
        label="设备坐标"
        placeholder="0,0"
        readonly
        :disabled="true"
        right-icon="location-o"
        @click="switchPanel('map')"
        :rules="[{ required: true, message: '设备坐标必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/lngLat.png" />
      </Field>
      <Field
        clearable
        v-model="device.address"
        label="详细地址"
        placeholder="请输入详细地址"
        type="textarea"
        autosize
        rows="1"
        :rules="[{ required: true, message: '详细地址必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/address.png" />
      </Field>
      <Field
        clearable
        label="安装位置"
        v-model="device.installLocation"
        placeholder="请输入安装位置"
        :rules="[{ required: true, message: '安装位置必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/installLocation.png" />
      </Field>
      <div
        style="display:flex;justify-content : space-between;width:80%;margin:auto;"
      >
        <UploadImage
          :imageList="image1"
          style="margin-top:5px;margin-left:-15px"
          top="设备图"
          type="DeviceImage"
          :count="1"
          @imageChange="image1Change"
          edit
        />
        <UploadImage
          :imageList="image2"
          style="margin-top:5px;margin-left:-15px"
          top="标签图"
          type="DeviceImage"
          :count="1"
          @imageChange="image2Change"
          edit
        />
        <UploadImage
          :imageList="image3"
          style="margin-top:5px;margin-left:-15px"
          top="安装图"
          type="DeviceImage"
          :count="1"
          @imageChange="image3Change"
          edit
        />
        <UploadImage
          :imageList="image4"
          style="margin-top:5px;margin-left:-15px"
          top="全景图"
          type="DeviceImage"
          :count="1"
          @imageChange="image4Change"
          edit
        />
      </div>
      <div v-if="deviceId == null">
        <pf code="DEVICE_ADD">
          <Button
            type="info"
            block
            style="width: 95% ; margin: 10px auto;"
            native-type="submit"
            >确认报装</Button
          >
        </pf>
      </div>
      <div v-else>
        <pf code="DEVICE_EDIT">
          <Button
            type="info"
            block
            style="width: 95% ; margin: 10px auto;"
            native-type="submit"
            >确认保存</Button
          >
        </pf>
      </div>
    </Form>
    <!-- <UnitPanel
      :show="unitPanel"
      type="unit"
      :units="unitTree"
      @panel="switchPanel"
    /> -->
    <UnitGroupPanel
      :group="group"
      :show="unitGroupPanel"
      @ok="onSelectGroup"
      @cancel="unitGroupPanel = false"
    />
    <SelectProductPopup
      :products="products"
      :show="productPanel"
      @ok="onSelectProduct"
      @cancel="productPanel = false"
    />
    <SelectTreePopup
      :show="unitPanel"
      :defaultSelected="
        device.unitId
          ? { id: device.unitId, name: device.unitName, areaId: areaId }
          : {}
      "
      :treeData="unitTree"
      :defaultTitle="device.unitName || '选择单位'"
      @ok="onUnitOk"
      @cancel="onUnitCancel"
    />
    <SelectTreePopup
      :show="areaPanel"
      :defaultSelected="
        device.areaId
          ? {
              id: device.areaId,
              name: device.areaName,
              lng: device.lng,
              lat: device.lat,
            }
          : {}
      "
      :treeData="areas"
      :defaultTitle="device.areaName || '选择区域'"
      @ok="onAreaOk"
      @cancel="onAreaCancel"
    />
    <MapPanel
      :show="mapPanel"
      :areaId="device.areaId"
      @panel="switchPanel"
      :lng="device.lng"
      :lat="device.lat"
      type="map"
    />
  </div>
</template>

<script>
import { Button, Field, Form, Loading, Dialog } from "vant";
import SelectProductPopup from "@/components/SelectPopup/SelectProductPopup";
import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup";
import UnitPanel from "@/components/UnitPanel";
import UnitGroupPanel from "@/components/UnitGroupPanel";
import AreaPanel from "@/components/AreaPanel";
import UploadImage from "@/components/UploadImage";
import MapPanel from "@/components/MapPanelreport";
import WeChatIcon from "@/components/Icon/WeChatIcon";
import { mapGetters } from "vuex";
import wx from "weixin-js-sdk";

export default {
  components: {
    Form,
    Field,
    UploadImage,
    Button,
    SelectProductPopup,
    UnitPanel,
    AreaPanel,
    SelectTreePopup,
    MapPanel,
    Loading,
    WeChatIcon,
    Dialog,
    UnitGroupPanel,
  },
  props: {},
  data() {
    return {
      deviceId: this.$route.params.id,
      code: false,
      device: {
        id: null,
        sn: null,
        address: null,
        installLocation: null,
        unitId: null,
        unitName: null,
        productId: null,
        productName: null,
        productKey: null,
        areaId: null,
        areaName: null,
        lat: "0",
        lng: "0",
        location: "",
        ioTHubRemark: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        unitGroupId: null,
        unitGroupName: null,
      },
      productPanel: false,
      unitPanel: false,
      areaPanel: false,
      mapPanel: false,
      unitGroupPanel: false,
      data: [],
      areas: [],
      products: [],
      group: [],
    };
  },
  computed: {
    disabledSn() {
      return !!this.deviceId;
    },
    disabledUnit() {
      return !!this.deviceId;
    },
    disabledUnitGroup() {
      return !this.device.unitId;
    },
    disabledProduct() {
      return !!this.deviceId || !this.device.unitId;
    },
    disabledMap() {
      return !this.device.areaId;
    },
    image1() {
      return this.device.image1 ? [this.device.image1] : [];
    },
    image2() {
      return this.device.image2 ? [this.device.image2] : [];
    },
    image3() {
      return this.device.image3 ? [this.device.image3] : [];
    },
    image4() {
      return this.device.image4 ? [this.device.image4] : [];
    },
    ...mapGetters({ unitTree: "global/unitList" }),
  },
  created() {
    if (this.deviceId == null) {
      const unit = this.$initUnit(this.device);
      unit && this.changeUnit(unit);
      this.$initProduct(this.device);
      //this.$initArea(this.device)
      //this.$initArea(this.device, {'lng': 'lng', 'lat': 'lat'})
    }
  },
  mounted() {
    if (this.deviceId != null) {
      this.getDeviceDetail();
    } else if (this.$route.params.sn) {
      this.device.sn = this.$route.params.sn;
    } else {
      this.qrScan();
    }
  },
  methods: {
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let resultStr = res.resultStr;
          let index = resultStr.indexOf(`CODE_128,`);
          if (index > -1) {
            let len = resultStr.length;
            resultStr = resultStr.slice(index + 9, len - 1);
          }
          if (This.code && resultStr.indexOf(`ys7`) == 0) {
            let Str = resultStr.replace(/\s*/g, "");
            This.device.sn = Str.substring(3, 12);
            This.device.ioTHubRemark = Str.substring(12, 18);
            this.onRefresh();
          } else if (This.device.productKey === `pro_06bc1eaf688f`) {
            let str = resultStr;
            let arr = str.split(`;`);
            if (Array.isArray(arr) && arr.length !== 0) {
              This.device.sn = arr[0];
            } else {
              This.device.sn = resultStr;
            }
          } else if (This.device.productKey === `pro_c0aff6a3d5a5`) {
            let str = resultStr;
            let arr = str.split(`,`);
            if (Array.isArray(arr) && arr.length !== 0) {
              This.device.sn = arr[0];
            } else {
              This.device.sn = resultStr;
            }
          } else {
            This.device.sn = resultStr;
            this.onRefresh();
          }
        },
      });
    },
    changeUnit(unit) {
      this.device.unitId = unit.id;
      this.device.unitName = unit.name;
      this.areaId = unit.areaId;
      this.getAreas(unit.areaId);
      this.getProducts(unit.id);
      this.getUnitGroup(unit.id);
    },
    onUnitCancel() {
      this.unitPanel = false;
    },
    onUnitOk(data) {
      this.unitPanel = false;
      if (data.areaId) {
        this.changeUnit(data);
      }
    },
    onAreaCancel() {
      this.areaPanel = false;
    },
    onAreaOk(data) {
      console.error("选择区域", data);
      this.areaPanel = false;
      this.device.areaId = data.id;
      this.device.areaName = data.name;
      this.device.lat = data.lat;
      this.device.lng = data.lng;
    },
    switchPanel(type, data) {
      switch (type) {
        case "map":
          if (data && data !== "map") {
            if (data[0] !== 0 && data[1] !== 0) {
              let This = this;
              new AMap.Geocoder().getAddress(data, function(status, result) {
                This.device.address = result.regeocode.formattedAddress;
              });
              this.device.lng = data[0];
              this.device.lat = data[1];
            }
          }
          this.mapPanel = !this.mapPanel;
          break;
        default:
          break;
      }
    },
    getProducts(unitId) {
      this.$http.tokiot.sys.product.listAuthorized({ unitId }).then((res) => {
        if (res) {
          this.products = res;
        }
      });
    },

    getUnitGroup(unitId) {
      let size = 999;
      this.$http.tokiot.sys.unit.group.list({ unitId, size }).then((res) => {
        this.group = res.rows;
      });
    },

    selectProduct() {
      this.productPanel = true;
    },
    onCancel() {
      this.productPanel = false;
    },
    onSelectProduct(product) {
      if (
        product.productForm == `Camera` &&
        product.productModel.indexOf(`HIK`) == 0
      ) {
        this.code = true;
      } else {
        this.code = false;
      }
      (this.device.productKey = product.productKey),
        (this.device.productName = product.productName);
      this.device.productId = product.id;
      this.productPanel = false;
    },
    onSelectGroup(group) {
      if (group.id) {
        this.device.unitGroupName = group.groupName;
        this.device.unitGroupId = group.id;
      }
      this.unitGroupPanel = false;
    },
    getAreas(areaId) {
      this.$http.tokiot.sys.area.v2.tree({ id: areaId }).then((areas) => {
        if (areas) {
          this.areas = [areas];
        }
      });
    },

    getDeviceDetail() {
      this.$http.tokiot.device
        .get({ id: this.deviceId, getUnitGroup: true })
        .then((res) => {
          if (res) {
            this.device = res;
            this.getUnitGroup(this.device.unitId);
          }
        });
    },

    submit() {
      if (this.deviceId == null) {
        this.$http.tokiot.device.create(this.device).then((res) => {
          this.$toast.clear();
          if (res) {
            this.$toast.success("设备报装成功");
            let result = this.device.name + "，已安装成功";
            Dialog.confirm({
              title: "安装提示",
              message:
                result +
                "\n点击返回，将返回首页\n点击继续，将复制当前信息再次安装",
              confirmButtonText: "继续",
              cancelButtonText: "返回",
            })
              .then(() => {})
              .catch(() => {
                this.$router.history.go(-1);
              });
          }
        });
      } else {
        this.$toast.loading("正在处理中...");
        this.$http.tokiot.device.update(this.device).then((res) => {
          if (res) {
            this.$toast.success("修改成功");
            setTimeout(() => {
              this.$router.history.go(-1);
            }, 500);
          }
        });
      }
    },
    image1Change(imageList) {
      this.device.image1 = imageList[0];
    },
    image2Change(imageList) {
      this.device.image2 = imageList[0];
    },
    image3Change(imageList) {
      this.device.image3 = imageList[0];
    },
    image4Change(imageList) {
      this.device.image4 = imageList[0];
    },
    empty() {
      this.device.unitGroupName = "";
      this.device.unitGroupId = "";
    },
  },
  watch: {
    "device.lng"() {
      this.device.location = this.device.lng + "," + this.device.lat;
    },
    "device.lat"() {
      this.device.location = this.device.lng + "," + this.device.lat;
    },
  },
};
</script>

<style></style>